enum BiteLogStripeEvent {
  None = 0,
  PaymentIntent = 1,
  PaymentIntentError = 2,
  Refund = 3,
  RefundError = 4,
  TokenizationError = 5,
  TerminalDisconnected = 6,
}

export { BiteLogStripeEvent };
